import { render, staticRenderFns } from "./newAccountModal.vue?vue&type=template&id=8f8fec9e&scoped=true&"
import script from "./newAccountModal.vue?vue&type=script&lang=js&"
export * from "./newAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8fec9e",
  null
  
)

export default component.exports